import type { ColumnDef } from '@tanstack/react-table';
import type React from 'react';
import Table from '@/components/UI/Table';
import type { DistrictBreakdownTableRow } from './dashboard.types';
import SectionCard from './SectionCard';

interface DistrictBreakdownTableProps {
  data: DistrictBreakdownTableRow[];
  columns: ColumnDef<DistrictBreakdownTableRow, any>[];
  className?: string;
  isLoading?: boolean;
}

const DistrictBreakdownTable: React.FC<DistrictBreakdownTableProps> = ({ data, columns, className, isLoading = false }) => (
  <SectionCard className={className} title='District Breakdown'>
    <div className='bg-white rounded-lg -m-5'>
      <Table cols={columns} tableData={data} fetching={isLoading} />
    </div>
  </SectionCard>
);

export default DistrictBreakdownTable;
